import { useState } from "react";
import { useSnackbar, VariantType } from "notistack";
import { cancelMySelfonboardingRequest } from "../api/selfonboardingHttpClient";

export const useCancelMySelfonboarding = (projectId: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isCancelling, setIsCancelling] = useState(false);

  const showSnackbar = (message: string, variant: VariantType) => {
    enqueueSnackbar(message, {
      variant: variant,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  };

  const cancelHandler = async () => {
    setIsCancelling(true);
    try {
      await cancelMySelfonboardingRequest(projectId);
      showSnackbar(
        "Your access request has been cancelled successfully",
        "success"
      );
      setIsCancelling(false);
      return true; // Indicate success
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Unable to cancel the request. Please contact administrator.";
      showSnackbar(errorMessage, "error");
      setIsCancelling(false);
      return false; // Indicate failure
    }
  };

  return { cancelHandler, isCancelling };
};
